import nestedCircles from "./nested-circles.html";
import "./nested-circles.css";

export default nestedCircles;
